"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalSearchResponseDto = exports.GlobalSearchResponseItemDto = exports.GlobalSearchItemType = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.GlobalSearchItemType = {
    CALENDAR: 'CALENDAR',
    ROOMS: 'ROOMS',
    SEARCH: 'SEARCH',
};
exports.GlobalSearchResponseItemDto = zod_1.z.object({
    type: zod_1.z.nativeEnum(exports.GlobalSearchItemType),
    placeholder: zod_1.z.string().nullish(),
    action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
    logMeta: zod_1.z.object({ object: zod_1.z.string() }),
});
exports.GlobalSearchResponseDto = zod_1.z.object({
    header: common_1.CommonWidgetV2HeaderDto.nullish(),
    items: zod_1.z
        .array(zod_1.z.object({
        items: zod_1.z.array(exports.GlobalSearchResponseItemDto),
    }))
        .nullish(),
    logMeta: zod_1.z.record(zod_1.z.unknown()),
});
